import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useView } from '../context/ViewContext';
import '../App.css'; // Reuse styles

const Login = () => {
    const navigate = useNavigate();
    const { refreshUser } = useView();
    const [role, setRole] = useState('distributor'); // Default
    const [formData, setFormData] = useState({
        phone: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
    };

    const handleRoleSelect = (selectedRole) => {
        setRole(selectedRole);
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Use FormData to match the working Registration flow
            const payload = new FormData();
            payload.append('phone', formData.phone);
            payload.append('password', formData.password);
            payload.append('role', role);

            const response = await axios.post('https://rotica.in/login.php', payload);

            if (response.data.success) {
                // Login Success
                const user = response.data.user;
                alert(`Welcome back, ${user.name}!`);

                // Save to localStorage (Optional, for session)
                localStorage.setItem('user', JSON.stringify(user));
                refreshUser();

                // Redirect to Dashboard (or Home)
                navigate('/dashboard');
            } else {
                setError(response.data.message || "Login failed");
            }
        } catch (err) {
            console.error(err);
            if (err.response) {
                // Server responded with a status code other than 2xx
                setError(`Server Error: ${err.response.status} - ${err.response.data?.message || JSON.stringify(err.response.data)}`);
            } else if (err.request) {
                // Request was made but no response received (CORS or Network)
                setError("Network Error: No response received. Please check your internet or if the server is reachable.");
            } else {
                // Something else happened
                setError(`Error: ${err.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="registration-container"> {/* Reusing container style */}
            <div className="registration-card">
                <div className="brand-header">
                    <h1>Rotica</h1>
                    <p>Partner Login</p>
                </div>

                <div className="form-header">
                    <h2>Welcome Back</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    {/* Role Selection */}
                    <div className="role-selection" style={{ marginBottom: '20px' }}>
                        <button
                            type="button"
                            className={`role-btn ${role === 'distributor' ? 'active' : ''}`}
                            onClick={() => handleRoleSelect('distributor')}
                        >
                            Distributor
                        </button>
                        <button
                            type="button"
                            className={`role-btn ${role === 'manufacturer' ? 'active' : ''}`}
                            onClick={() => handleRoleSelect('manufacturer')}
                        >
                            Manufacturer
                        </button>
                    </div>

                    <div className="input-group">
                        <label>Phone Number</label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder="Enter your registered phone"
                        />
                    </div>

                    <div className="input-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            placeholder="Enter your password"
                        />
                    </div>

                    {error && <p className="error-text">{error}</p>}

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>

                    <button
                        type="button"
                        className="forgot-password"
                        onClick={() => navigate('/')} // Assuming Register IS home, or change path
                        style={{ marginTop: '15px' }}
                    >
                        New User? Create Account
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
